import { Trash2 } from "lucide-react";
import { useIntl } from "react-intl";

import { successToast } from "../../../../../atoms/toast";
import {
  DataFormToolbarButton,
  DataFormToolbarLayout,
} from "../../../../../data-form";
import { useDataFormPreferencesContext } from "../../context";
import { useDeleteDataTablePreferenceMutation } from "../../mutation";
import { DataFormPreferencesToolbarCancelButton } from "./data-form-toolbar-cancel-button";
import { DataFormPreferencesSaveButton } from "./data-form-toolbar-save-button";

export function DataFormPreferenceDeleteButton() {
  const intl = useIntl();
  const { setMode } = useDataFormPreferencesContext();

  return (
    <DataFormToolbarButton
      color="error"
      icon={{ Icon: Trash2 }}
      tooltip={intl.formatMessage({
        id: "data-table.preference.delete",
        defaultMessage: "Smazat",
      })}
      onClick={() => setMode("delete")}
    />
  );
}

export function DataFormPreferenceDeleteAction() {
  const intl = useIntl();
  const { setEntity, setMode } = useDataFormPreferencesContext();
  const mutation = useDeleteDataTablePreferenceMutation();

  return (
    <DataFormToolbarLayout>
      <DataFormPreferencesToolbarCancelButton />

      <DataFormPreferencesSaveButton
        isLoading={mutation.isPending}
        iconLeft={{ Icon: Trash2 }}
        onClick={async () => {
          await mutation.mutateAsync();

          setMode("detail");
          setEntity(null);

          successToast(
            intl.formatMessage({
              id: "data-form-preferences.delete.sucess.title",
              defaultMessage: "Data byla úspěšně smazána.",
            }),
          );
        }}
      >
        {intl.formatMessage({
          id: "data-form-preferences.delete",
          defaultMessage: "Smazat",
        })}
      </DataFormPreferencesSaveButton>
    </DataFormToolbarLayout>
  );
}
